import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SITE_SETTINGS } from 'src/app/settings';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  settings = SITE_SETTINGS;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  back() {
    this.router.navigateByUrl('/');
  }

}
